import gql from 'graphql-tag';

const UserFragment = gql`
  fragment UserFragment on PeopleModel {
    id
    email
    cookie_id
    cartCookieId
    status_id
    settingsItem {
      epp_catalog
      catalog_sorting
    }
  }
`;

const AuthQuery = {
  authorization: gql`
    mutation login($email: String!, $password: String!) {
      login(password: $password, email: $email) {
        ...UserFragment
      }
    }
    ${UserFragment}
  `,
  authInfo: gql`
    query me {
      me {
        ...UserFragment
      }
    }
    ${UserFragment}
  `,
  registration: gql`
    mutation register($data: RegisterInput!) {
      register(data: $data) {
        ...UserFragment
      }
    }
    ${UserFragment}
  `,
  resetPass: gql`
    mutation forgotPassword($email: String!) {
      forgotPassword(email: $email)
    }
  `,
  partnerLoginOrRegister: gql`
    mutation partnerLoginOrRegister(
      $state: String!
      $code: String!
      $session_state: String!
      $partnerId: Int
      $forMenu: Boolean
    ) {
      partnerLoginOrRegister(
        state: $state
        code: $code
        session_state: $session_state
        partnerId: $partnerId
        forMenu: $forMenu
      ) {
        success
        info
        people {
          id
          email
          cookie_id
          cartCookieId
          status_id
          settingsItem {
            epp_catalog
            catalog_sorting
          }
        }
      }
    }
  `,
  logout: gql`
    mutation logout {
      logout
    }
  `,
  loginOrRegisterBySms: gql`
    mutation loginOrRegisterBySms(
      $phone: String!
      $code: Int
      $action: PeopleSmsAction
      $partnerId: Int
      $token: String!
      $courierId: Int
      $isMenu: Boolean
    ) {
      loginOrRegisterBySms(
        phone: $phone
        code: $code
        partnerId: $partnerId
        action: $action
        token: $token
        courierId: $courierId
        isMenu: $isMenu
      ) {
        success
        info
        people {
          id
          email
          cookie_id
          cartCookieId
          status_id
          settingsItem {
            epp_catalog
            catalog_sorting
          }
        }
        error
        errorCode
      }
    }
  `,
  loginOrRegisterByEmail: gql`
    mutation loginOrRegisterByEmail(
      $data: RegisterInput!
      $action: PeopleSmsAction
    ) {
      loginOrRegisterByEmail(data: $data, action: $action) {
        success
        info
        peopleExist
        people {
          id
          email
          cookie_id
          cartCookieId
          status_id
          settingsItem {
            epp_catalog
            catalog_sorting
          }
        }
        error
        errorCode
      }
    }
  `,
  checkPeopleExist: gql`
    query checkPeopleExist($email: String!) {
      checkPeopleExist(email: $email)
    }
  `,
  loginByPhoneAnyWay: gql`
    mutation loginByPhoneAnyWay($phone: String!, $storeId: Int) {
      loginByPhoneAnyWay(phone: $phone, storeId: $storeId) {
        success
        error
        errorCode
        info
        people {
          id
          email
          cookie_id
          cartCookieId
          status_id
          access_email
          activated
          active
          cln_del
          phone
          settingsItem {
            epp_catalog
            catalog_sorting
          }
        }
        peopleExist
      }
    }
  `,
  maxLoginStart: gql`
    mutation maxLoginStart {
      maxLoginStart {
        success
        error
        code
        link
        ttl
      }
    }
  `,
  maxLoginCheck: gql`
    mutation maxLoginCheck($code: String!) {
      maxLoginCheck(code: $code) {
        success
        info
        error
        errorCode
        people {
          id
          cookie_id
          cartCookieId
          settingsItem {
            epp_catalog
            catalog_sorting
          }
        }
      }
    }
  `
};
export default AuthQuery;
